import React from 'react';
import { Avatar, Card, List } from 'antd';
import { CloudOutlined, VideoCameraOutlined, Html5Outlined } from '@ant-design/icons';
import placeholder from '../../../../../../../../assets/icons/photo/placeholder.png';
import { ExtraInfo } from '../../../attribution/components/ExtraInfo';

const Top = ({ data, title, topCount = 10, imageIndex = '', currentUser }) => {
  const topData = data.slice(0, topCount);
  
  const isVideoType = (item) => {
    if (item.media && item.media.type) {
      return item.media.type.toLowerCase() === 'video' || item.media.type === 'THREEDEE';
    }
    // Fallback checker - check if creativeUrl contains video file extensions
    if (item.creativeUrl || item[imageIndex]) {
      const url = item.creativeUrl || item[imageIndex];
      const videoExtensions = ['.mp4', '.mov', '.avi', '.webm', '.ogv', '.3gp', '.flv'];
      return videoExtensions.some(ext => url.toLowerCase().includes(ext));
    }
    return false;
  };

  const isHTML5Type = (item) => {
    if (item.media && item.media.type) {
      return item.media.type.toLowerCase() === 'html5' || item.media.type === 'HTML5';
    }
    // Fallback checker - check if creativeUrl contains html file extensions or is a zip
    if (item.creativeUrl || item[imageIndex]) {
      const url = item.creativeUrl || item[imageIndex];
      const html5Extensions = ['.html', '.htm', '.zip'];
      return html5Extensions.some(ext => url.toLowerCase().includes(ext));
    }
    return false;
  };
  
  const avatarImg = (item) => {
    if (imageIndex !== '') {
      if (item[imageIndex]) {
        return item[imageIndex];
      } else {
        return placeholder;
      }
    }
    return '';
  };
  
  const getAvatarIcon = (item) => {
    if (title === 'Creatives') {
      const isVideo = isVideoType(item);
      const isHTML5 = isHTML5Type(item);
      
      if (isVideo) {
        return <VideoCameraOutlined />;
      } else if (isHTML5) {
        return <Html5Outlined />;
      }
    }
    return <CloudOutlined />;
  };

  const explanation = `Some app images in Top ${topCount} ${title} are unable to be displayed.`;

  return (
    <>
      <Card
        title={`Top ${topCount} ${title}`}
        extra={<ExtraInfo placement="topRight" title={explanation} />}
      >
        <List
          itemLayout="horizontal"
          dataSource={topData}
          renderItem={(item) => (
            <List.Item style={{ padding: '12px 0' }}>
              <List.Item.Meta 
                avatar={
                  <Avatar 
                    src={avatarImg(item) === '' || !avatarImg(item) ? false : avatarImg(item)}
                    icon={getAvatarIcon(item)}
                  />
                } 
                title={
                  <div style={{ 
                    wordWrap: 'break-word',
                    wordBreak: 'break-word',
                    whiteSpace: 'normal',
                    maxWidth: '100%',
                    paddingRight: '8px'
                  }}>
                    {item.xAxis}
                  </div>
                } 
              />
            </List.Item>
          )}
        />
      </Card>
    </>
  );
};

export default Top;
